import React from 'react';
import PropTypes from 'prop-types';
import { forEach as _forEach } from 'lodash';

import EditionPreviews from '../campaigns/EditionPreviews';
import { S3_BUCKETS } from 'js/constants';

CartWizardStepMediaNavigator.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  edition: PropTypes.object,
};

function CartWizardStepMediaNavigator({ edition = {} }) {
  const printDataPreviews = [];
  _forEach(edition?.template?.print_data_previews, preview => {
    printDataPreviews.push({
      key:
        'https://s3.eu-central-1.amazonaws.com/' +
        S3_BUCKETS.TEMPLATES +
        '/' +
        edition?.template?.id +
        '/images/' +
        preview,
    });
  });

  const editionPreviews = edition?.template?.direct_ordering ? printDataPreviews : edition?.previews ?? [];
  const previewRemountKey = [edition?.id, edition?.mdate, edition?.previews_state, editionPreviews[0]?.key]
    .filter(Boolean)
    .join('_');

  return (
    <div className="wizard-step-media-navigator">
      <div className="details-content">
        <EditionPreviews
          key={previewRemountKey}
          editionId={edition?.id}
          editionPreviews={editionPreviews}
          type={edition?.template?.export_type?.value}
        />
      </div>
    </div>
  );
}

export default CartWizardStepMediaNavigator;
